<template>
  <div id="app">
    <v-app id="inspire">
      <v-card-title>
        <span class="headline">{{formTitle}}</span>
      </v-card-title>
      <v-container grid-list-xl>
        <v-form
          ref="form"
          v-model="valid"
          lazy-validation>
          <v-tabs 
            grow
            slider-color="blue"
            color="#eeeeee">
            <v-tab ripple>
                Informações
            </v-tab>
            <v-tab ripple>
                Alíquota
            </v-tab>
            <v-tab ripple>
                Modalidade
            </v-tab>

            <v-tab-item>
                <v-layout
                    class="mt-3"
                    row
                    align-end
                    justify-space-between
                >
                    <v-flex xs12 sm12 md5>
                    <v-text-field v-model="newTributo.codigo" label="Código"  counter="10" :rules="codRules"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 md5>
                    <v-text-field v-model="newTributo.nome" label="Nome" :rules="nomeRules" required></v-text-field>
                    </v-flex>
                </v-layout>
                <v-layout
                    row
                    justify-space-between
                >
                    <v-flex xs12 sm12 md5>
                        <v-combobox
                            v-model="newTributo.tp_tributo"
                            :items="tipoTributo"
                            label="Tipo de Tributo"
                            hide-no-data
                            hide-selected
                            item-text="nome"
                            item-value="id"
                            placeholder="Comece a digitar para procurar"
                            return-object
                            :rules="obrigatorioRules"
                        >
                        </v-combobox>
                    </v-flex>
                </v-layout>
            </v-tab-item>
            <v-tab-item>
                <v-layout
                    row
                    class="mt-3"
                    justify-space-between
                >
                    <v-flex xs12 sm12 md5>
                    <v-text-field v-model="newTributo.aliquota" label="Alíquota"  type="number" min="0" max="1" step="0.01" :rules="obrigatorioRules"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 md5>
                        <v-text-field v-model="newTributo.aliquota_reduzida" label="Alíquota Reduzida" type="number" min="0" max="1" step="0.01"></v-text-field>
                    </v-flex>
                </v-layout>
                <v-layout
                    row
                    justify-space-between
                    >
                    <v-flex xs12 sm12 md5>
                        <v-text-field v-model="newTributo.aliquota_diferida" label="Alíquota Diferida" type="number" min="0" max="1" step="0.01"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 md5>
                        <v-text-field v-model="newTributo.aliquota_icms_fcp" label="Alíquota FCP" type="number" min="0" max="1" step="0.01" ></v-text-field>
                    </v-flex>
                </v-layout>
                <v-layout
                    row
                    justify-space-between
                    >
                    <v-flex xs12 sm12 md5>
                        <v-text-field v-model="newTributo.aliquota_mva" label="Alíquota MVA" type="number" min="0" max="1" step="0.01"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 md5>
                        <v-text-field v-model="newTributo.aliquota_icms_interno_st" label="Alíquota Interno ST" type="number" min="0" max="1" step="0.01"></v-text-field>
                    </v-flex>
                </v-layout>
                <v-layout
                    row
                    justify-space-between
                    >
                    <v-flex xs12 sm12 md5>
                        <v-text-field v-model="newTributo.aliquota_icms_interestadual_st" label="Alíquota Interest. ST" type="number" min="0" max="1" step="0.01"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 md5>
                        <v-text-field v-model="newTributo.aliquota_cred_icms_simples" label="Alíquota Crédito ICMS ST (Simples)" type="number" min="0" max="1" step="0.01"></v-text-field>
                    </v-flex>
                </v-layout>
                <v-layout
                    row
                    justify-space-between
                    >
                    <v-flex xs12 sm12 md5>
                        <v-text-field v-model="newTributo.aliquota_icms_partilha_fcp" label="Alíquota FCP" type="number" min="0" max="1" step="0.01"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 md5>
                        <v-text-field v-model="newTributo.aliquota_icms_partilha_interestadual" label="Alíquota - ICMS Interestadual" type="number" min="0" max="1" step="0.01"></v-text-field>
                    </v-flex>
                </v-layout>
                <v-layout
                    row
                    justify-space-between
                    >
                    <v-flex xs12 sm12 md5>
                        <v-text-field v-model="newTributo.aliquota_icms_partilha_ufdestino" label="Alíquota - ICMS UF Destino" type="number" min="0" max="1" step="0.01" ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 md5>
                        <v-text-field v-model="newTributo.aliquota_icms_partilha_difal" label="Alíquota - ICMS DIFAL Partilha" type="number" min="0" max="1" step="0.01"></v-text-field>
                    </v-flex>
                </v-layout>
            </v-tab-item>
            <v-tab-item>
                <v-layout
                    row
                    class="mt-3"
                    justify-space-between
                    >
                    <v-flex xs12 sm12 md5>
                        <v-combobox
                            v-model="newTributo.tp_modalidade_icms"
                            :items="modalidade"
                            hide-no-data
                            hide-selected
                            item-text="nome"
                            item-value="id"
                            label="Base de cálculo ICMS"
                            placeholder="Comece a digitar para procurar"
                            return-object
                        ></v-combobox>
                    </v-flex>
                    <v-flex xs12 sm12 md5>
                        <v-combobox
                            v-model="newTributo.tp_modalidade_icms_st"
                            :items="baseCalculo"
                            hide-no-data
                            hide-selected
                            item-text="nome"
                            item-value="id"
                            label="Base de cálculo ICMSST"
                            placeholder="Comece a digitar para procurar"
                        ></v-combobox>
                    </v-flex>
                </v-layout>
                <v-layout
                    row
                    justify-space-between
                >
                     <v-flex xs12 sm12 md5>
                        <v-combobox
                            v-model="newTributo.tp_motivo_desoneracao_icms"
                            :items="motivoDesoneracao"
                            hide-no-data
                            hide-selected
                            item-text="nome"
                            item-value="id"
                            label="Motivo Desoneração ICMS"
                            placeholder="Comece a digitar para procurar"
                        ></v-combobox>
                    </v-flex>
                </v-layout>
            </v-tab-item>
        </v-tabs>
        </v-form>
        <v-layout
            class="mt-4"
            row
            align-end
        >
            <v-btn
            class="ml-2"
            color="success"
            @click="criarTributo"
            >
            Salvar
            </v-btn>

            <v-btn
            color="error"
            @click="reset"
            >
            Cancelar
            </v-btn>

            <v-btn
            color="warning"
            @click="back"
            >
            Voltar
            </v-btn>
        </v-layout>
        <v-layout
            class="mt-4">
            <v-flex xs12 md12>
                <v-textarea
                    v-if="this.envio !== ''"
                    disabled
                    outline
                    no-resize
                    rows = "5"
                    name="inputEnvio"
                    label="Envio"
                    :value="this.envio"
                ></v-textarea>
            </v-flex>
        </v-layout>
        <v-layout>
            <v-flex xs12 md12>
                <v-textarea
                    v-if="this.mostrar !== ''"
                    disabled
                    outline
                    no-resize
                    color="purple"
                    rows = "5"
                    name="inputMostrar"
                    label="Resposta"
                    :value="this.mostrar"
                ></v-textarea>
            </v-flex>
        </v-layout>
      </v-container>

    </v-app>
  </div>
</template>

<script>
    import {sharedService} from '../services'

    export default {
        name: 'TributosForm',
        data() {
            return {
                envio: '',
                mostrar: '',
                editedIndex: -1,
                newTributo:{
                    codigo: '',
                    nome: '',
                    tp_tributo: '',
                    aliquota: '',
                    aliquota_reduzida: '',
                    aliquota_diferida: '',
                    aliquota_icms_fcp: '',
                    aliquota_mva: '',
                    aliquota_icms_interno_st: '',
                    aliquota_icms_interestadual_st:'',
                    aliquota_cred_icms_simples: '',
                    aliquota_icms_partilha_fcp: '',
                    aliquota_icms_partilha_interestadual: '',
                    aliquota_icms_partilha_ufdestino: '',
                    aliquota_icms_partilha_difal: '',
                    tp_modalidade_icms: '',
                    tp_modalidade_icms_st: '',
                    tp_motivo_desoneracao_icms: ''
                },
                codRules: [
                    v => v.length <= 10 || 'Máximo 10 caracteres'
                ],
                nomeRules: [
                    v => !!v || 'Este campo é obrigatório',
                    v => v.length <= 120 || 'Máximo 120 caracteres'
                ],
                obrigatorioRules: [
                    v => !!v || 'Este campo é obrigatório'
                ],
                modalidade: [
                    {id: '0', nome: '0-Margem valor adicionado'},
                    {id: '1', nome: '1-Pauta (valor)'},
                    {id: '2', nome: '2-Preço tabelado máx. (valor)'},
                    {id: '3', nome: '3-Valor da operação'}
                ],
                baseCalculo: [
                    {nome: '0-Valor da operação',id: '0'},
                    {nome: '1-Lista negativa (valor)',id:'1'},
                    {nome: '2-Lista positiva (valor)',id:'2'},
                    {nome: '3-Lista positiva (valor)',id:'3'},
                    {nome: '4-Margem valor adic. (%) ',id:'4'},
                    {nome: '5-Pauta (valor)',id:'5'}
                ],
                motivoDesoneracao: [
                    {nome: '1-Táxi', id:1},
                    {nome: '2-Deficiente Físico', id:2},
                    {nome: '3-Produtor Agropecuário', id:3},
                    {nome: '4-Frotista / Locadora ', id:4},
                    {nome: '5-Diplomático / Consular', id:5},
                    {nome: '6-Utilitários e Motocicletas da Amazônia Ocidental e Áreas de Livre Comércio (Resolução 714/88 e 790/94 – CONTRAN)', id:6}
                ],
                tipoTributo:[ 
                    { id: 'ICMS', nome: 'ICMS'},
                    { id: 'IPI', nome: 'IPI'},
                    { id: 'IPI', nome: 'IPI'},
                    { id: 'ISS', nome: 'ISS'}, 
                    { id: 'PIS', nome: 'PIS'}, 
                    { id: 'COFINS', nome: 'COFINS'},
                    { id: 'ICMSST', nome: 'ICMSST'}, 
                    { id: 'PISST', nome: 'PISST'}, 
                    { id: 'COFINSST', nome: 'COFINSST'}, 
                    { id: 'INSS', nome: 'INSS'}, 
                    { id: 'IR', nome: 'IR'},
                    { id: 'CSLL', nome: 'CSLL'}
                    ],
                valid: true,
                text: ''
            }
        },
        created () {
            if (this.$route.params.id) {
                this.id = this.$route.params.id
                this.editedIndex = 1
                this.getData()
            } else {
                this.editedIndex = -1
            }
        },
        computed: {
            formTitle () {
                return this.editedIndex === -1 ? 'Novo Tributo' : 'Edita Tributo'
            }
        },
        methods: {
            criarTributo() {
                let self = this
                if(this.editedIndex === -1){
                    this.$confirm('Tem certeza que deseja salvar este item?').then(res => {
                        if (res) {
                            if (this.$refs.form.validate()) {
                                sharedService.create('Tributos', this.newTributo).then(function (obj){
                                    self.envio = JSON.stringify(self.newTributo)
                                    obj.text().then(function (text){
                                        self.mostrar = text
                                        if(obj.status === 200){
                                            self.$store.dispatch('success', 'Tributo cadastrado com sucesso!')
                                        }  else {
                                            self.$store.dispatch('error', text)
                                        }
                                    })
                                })
                            } else {
                                alert('Preencha os campos obrigatórios!')
                            }
                        } else {
                            this.close()
                        }
                    })
                } else {
                        this.$confirm('Tem certeza que deseja editar este item?').then(res => {
                        if (res) {
                            if (this.$refs.form.validate()) {
                                sharedService.update('Tributos', this.newTributo, this.id).then(function (obj){
                                    self.envio = JSON.stringify(self.newTributo)
                                    obj.text().then(function (text){
                                        self.mostrar = text
                                        if(obj.status === 200){
                                            self.$store.dispatch('success', 'Tributo editado com sucesso!')
                                        }  else {
                                            self.$store.dispatch('error', text)
                                        }
                                    })
                                })
                            } else {
                                alert('Preencha os campos obrigatórios!')
                            }
                        } else {
                            this.close()
                        }
                    })
                }
            },
            back () {
                this.$router.push({
                name: 'Tributos'
                })  
            },
            reset () {
                this.$refs.form.reset()
            },
            getData: async function () {
                let self = this
                await sharedService.read('Tributos',{atributos: ['id','nome']}, this.id).then(function (obj){
                    self.newTributo.codigo = obj.codigo
                    self.newTributo.nome = obj.nome
                    self.newTributo.tp_tributo = obj.tp_tributo.nome
                    self.newTributo.aliquota = obj.aliquota
                    self.newTributo.aliquota_reduzida = obj.aliquota_reduzida
                    self.newTributo.aliquota_diferida = obj.aliquota_diferida
                    self.newTributo.aliquota_icms_fcp = obj.aliquota_icms_fcp
                    self.newTributo.aliquota_mva = obj.aliquota_mva
                    self.newTributo.aliquota_icms_interno_st = obj.aliquota_icms_interno_st
                    self.newTributo.aliquota_icms_interestadual_st = obj.aliquota_icms_interestadual_st
                    self.newTributo.aliquota_cred_icms_simples = obj.aliquota_cred_icms_simples
                    self.newTributo.aliquota_icms_partilha_fcp = obj.aliquota_icms_partilha_fcp
                    self.newTributo.aliquota_icms_partilha_interestadual = obj.aliquota_icms_partilha_interestadual
                    self.newTributo.aliquota_icms_partilha_ufdestino = obj.aliquota_icms_partilha_ufdestino
                    self.newTributo.aliquota_icms_partilha_difal = obj.aliquota_icms_partilha_difal
                    self.newTributo.tp_modalidade_icms = obj.tp_modalidade_icms
                    self.newTributo.tp_modalidade_icms_st = obj.tp_modalidade_icms_st
                    self.newTributo.tp_motivo_desoneracao_icms = obj.tp_motivo_desoneracao_icms
                })
            }
        }
    }
</script>

<style scoped>
   
</style>
